import React from "react"
import PropTypes from "prop-types"
import styled from "@emotion/styled"
import {
  Box,
  Link,
  ArrowRightIcon,
  HeadingFour,
  Text,
  Flex,
  getImageSrc,
} from "datastory-shared/ui"
import { ConditionalWrap } from "datastory-shared/utils/components/ConditionalWrap"

const StyledBox = styled(Box)`
  @media (min-width: 44.9375rem) {
    svg {
      transition: transform 300ms;
    }
    &:hover {
      svg {
        transform: translateX(20px);
      }
    }
  }
`

export const Item = ({
  viewType,
  local_id,
  og_definition,
  og_name,
  og_datastoryGlossaryCategory,
  og_illustration,
  baseUrl,
  maxDefinitionCharacters = 80,
}) => {
  const name = og_name[0]?.i18n
  let definition = og_definition?.[0]?.i18n
  const image = og_illustration?.[0]

  if (
    viewType === "grid" &&
    definition &&
    definition.length > maxDefinitionCharacters
  )
    definition = `${definition.substr(
      0,
      definition.lastIndexOf(" ", maxDefinitionCharacters)
    )} ...`

  return (
    <Link
      href={`/services/glossary/${og_datastoryGlossaryCategory?.[0].entity_meta.local_id}/${local_id}`}
      _hover={{ textDecoration: "none" }}
      _focus={{
        colorScheme: "whiteAlpha",
      }}
      data-cy="item"
      variant="standalone"
    >
      <StyledBox
        className="content"
        borderRadius="md"
        border="1px solid"
        borderColor={"gray.100"}
        p="md"
        mb={[0, 0, "sm"]}
        _hover={{
          shadow: "lg",
          border: "1px solid",
          borderColor: "gray.100",
        }}
        _focusWithin={{
          shadow: "lg",
          border: "1px solid",
          borderColor: "gray.100",
        }}
        display={viewType === "listing" ? "flex" : "block"}
        flexDirection="row-reverse"
      >
        <ConditionalWrap
          condition={viewType === "listing"}
          wrap={children => (
            <Flex w="35%" alignItems="center">
              {children}
            </Flex>
          )}
        >
          {image?.entity_meta?.local_id ? (
            <>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={getImageSrc(image.entity_meta.local_id, baseUrl)}
                alt={`${name}`}
                style={{ width: "100%", objectFit: "cover" }}
              />
              <Box mb={["sm", "sm", 0]} />
            </>
          ) : null}
        </ConditionalWrap>

        <Box
          alignItems={["center", "center", "baseline"]}
          display={["flex", "flex", viewType === "listing" ? "flex" : "block"]}
          justifyContent="space-between"
          w={["100%", "100%", viewType === "listing" ? "65%" : "100%"]}
        >
          <ConditionalWrap
            condition={viewType === "listing"}
            wrap={children => <Box mr={[0, 0, "md"]}>{children}</Box>}
          >
            <HeadingFour py={[0, 0, "sm"]}>{name}</HeadingFour>
            <Text
              display={["none", "none", "block"]}
              pb="md"
              pt="sm"
              fontWeight="400"
            >
              {definition}
            </Text>
          </ConditionalWrap>
          {viewType === "grid" && (
            <ArrowRightIcon boxSize={6} color="primary.500" />
          )}
        </Box>
      </StyledBox>
    </Link>
  )
}

Item.propTypes = {
  local_id: PropTypes.string,
  definition: PropTypes.array,
  name: PropTypes.array,
  illustration: PropTypes.array,
  datastoryGlossaryCategory: PropTypes.array,
  viewType: PropTypes.string,
  maxDefinitionCharacters: PropTypes.number,
  baseUrl: PropTypes.string,
}
